import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Tabs,
  Tab,
  Divider,
  CircularProgress,
  Stack,
  IconButton,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  useTheme,
  useMediaQuery,
  alpha,
  Chip,
  TextField,
  Button,
  Grid,
  Fade,
} from "@mui/material";
import {
  ArrowBack,
  AddCircleOutline,
  ConfirmationNumber,
  Business,
  Schedule,
  Assignment,
  CheckCircle,
  Pending,
  Close,
  Mail,
  Phone,
  Person,
  AccessTime,
} from "@mui/icons-material";
import AttachFileIcon from "@mui/icons-material/AttachFile";

import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import TicketPage from "./TicketPage";
import { useSelector } from "react-redux";
import DownloadRounded from "@mui/icons-material/DownloadRounded";
import ImageOutlined from "@mui/icons-material/ImageOutlined";
import InsertDriveFileOutlined from "@mui/icons-material/InsertDriveFileOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { Menu, MenuItem } from "@mui/material";
import { MoreVert } from "@mui/icons-material";

const TicketDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery("(max-width:900px)");

  const [ticket, setTicket] = useState(null);
  const [comments, setComments] = useState([]);
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState(0);
  const [openForm, setOpenForm] = useState(false);
  const [newComment, setNewComment] = useState("");
  const [submittingComment, setSubmittingComment] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const isMenuOpen = Boolean(anchorEl);
  const [commentError, setCommentError] = useState("");

  const submitTicketRef = useRef(null);
  const [attachedImage, setAttachedImage] = useState(null);
  

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const url = URL.createObjectURL(file);
      setAttachedImage({ file, url });
      console.log("attachedImage", attachedImage);
    }
  };

  //   const handleImageChange = (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     const url = URL.createObjectURL(file);
  //     console.log("file",file)
  //     const newImage = { file, url };
  //     //setAttachedImage(newImage);
  //     console.log("attachedImage (new)", newImage.url); // ✅ always correct

  //     const id1 = newImage.url.split("/").pop();
  // console.log(id1);
  // const supabaseUrl = `https://itfupclpiaqqtilrxxik.supabase.co/storage/v1/object/public/ticketattachments/${id1}`;

  // console.log(supabaseUrl);
  // setAttachedImage(supabaseUrl)
  //   }
  // };

  const handleRemoveImage = () => {
    setAttachedImage(null);
    setCommentError("");
  };

  const formatDate = (iso) => new Date(iso).toLocaleString("en-IN");
  // Inside the component:
  const currentUser = useSelector((state) => state.Auth.user);

  const getStatusIcon = (status) => {
    switch (status?.toLowerCase()) {
      case "resolved":
        return <CheckCircle fontSize="small" />;
      case "open":
        return <Pending fontSize="small" />;
      case "closed":
        return <Close fontSize="small" />;
      default:
        return null;
    }
  };

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case "resolved":
        return "success";
      case "open":
        return "warning";
      case "closed":
        return "default";
      default:
        return "primary";
    }
  };

  const fetchTicket = async () => {
    try {
      setLoading(true);
      const res = await axios.get(
        `${process.env.REACT_APP_HELPDESK_API_URL}/api/user/getTicket/${id}`,
      );
      if (res.data && res.data.id) {
        setTicket(res.data);
      } else {
        setTicket(null);
      }
    } catch (err) {
      console.error("Error fetching ticket:", err);
      setTicket(null);
    } finally {
      setLoading(false);
    }
  };

  const fetchComments = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_HELPDESK_API_URL}/api/user/comments/${id}`,
      );
      if (res.data.success) {
        setComments(res.data.comments || []);
        console.log("comments", res.data.comments);
      }
    } catch (err) {
      console.error("Error fetching comments:", err);
    }
  };

  // const fetchHistory = async () => {
  //   try {
  //     const res = await axios.get(
  //       `https://helpdesk.vjerp.com/api/user/getReassingHistory/${id}`
  //     );

  //     console.log("History API Response:", res.data);

  //     // ✅ Directly set history because it's already an array
  //     if (Array.isArray(res.data)) {
  //       setHistory(res.data);
  //     } else if (res.data?.history) {
  //       setHistory(res.data.history);
  //     } else {
  //       setHistory([]);
  //     }
  //   } catch (err) {
  //     console.error("Error fetching ticket history:", err);
  //     setHistory([]);
  //   }
  // };

  // const handleAddComment = async () => {
  //   if (!newComment.trim()) return;
  //   setSubmittingComment(true);
  //   try {
  //     await axios.post(
  //       "https://helpdesk.vjerp.com/api/user/add-comment",
  //       {
  //         // user_id: ticket?.user?.id || null,
  //         user_id: currentUser?.id || null,
  //         ticket_id: ticket.id,
  //         message: newComment,
  //         userEmail: currentUser?.email || ticket?.customer_email,
  //         display_id: ticket?.display_id,
  //         customer_name: currentUser?.name || ticket?.customer_name,
  //         image : attachedImage || null

  //       }
  //     );
  //     setNewComment("");
  //     fetchComments();
  //   } catch (err) {
  //     console.error("Error adding comment:", err);
  //   } finally {
  //     setSubmittingComment(false);
  //   }
  // };

  const fetchHistory = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_HELPDESK_API_URL}/api/user/getReassingHistory/${id}`,
      );

      console.log("History API Response:", res.data);

      let historyData = [];

      if (Array.isArray(res.data)) {
        historyData = res.data;
      } else if (res.data?.history) {
        historyData = res.data.history;
      }

      // ✅ Sort latest first by created_at (or ticket_assigned_at if exists)
      historyData.sort(
        (a, b) =>
          new Date(b.ticket_assigned_at || b.created_at) -
          new Date(a.ticket_assigned_at || a.created_at),
      );

      setHistory(historyData);
    } catch (err) {
      console.error("Error fetching ticket history:", err);
      setHistory([]);
    }
  };

  const handleAddComment = async () => {
    // 🛑 If no comment & no image → just block silently
    if (!newComment.trim() && !attachedImage) return;

    // 🛑 If image is attached but no comment → show inline error
    if (attachedImage && !newComment.trim()) {
      setCommentError("Comment is required when attaching an image.");
      return;
    }

    setSubmittingComment(true);
    setCommentError(""); // clear any old error

    try {
      const formData = new FormData();

      // ✅ Only append if values exist (avoid empty string → UUID error)
      if (currentUser?.id) {
        formData.append("user_id", currentUser.id);
      }

      if (ticket?.id) {
        formData.append("ticket_id", ticket.id);
      }

      formData.append("message", newComment || "");
      formData.append(
        "userEmail",
        // currentUser?.email || ticket?.customer_email || ""
        ticket?.user?.email,
      );
      formData.append("display_id", ticket?.display_id || "");

      formData.append("mobile", ticket?.user?.mobile || "");
      formData.append("name", ticket?.user?.name || "");
      formData.append(
        "customer_name",
        currentUser?.name || ticket?.customer_name || "",
      );

      // ✅ Correct field name for file
      if (attachedImage?.file) {
        formData.append("attachments", attachedImage.file);
      }

      const response = await axios.post(
        `${process.env.REACT_APP_HELPDESK_API_URL}/api/user/add-comment`,
        formData,
      );

      if (response.data.success) {
        setNewComment("");
        setAttachedImage(null);
        fetchComments();
      } else {
        console.error("Failed to add comment:", response.data.message);
      }
    } catch (err) {
      console.error("Error adding comment:", err);
    } finally {
      setSubmittingComment(false);
    }
  };

  const handleMenuClose = () => setAnchorEl(null);

  const handleUpdateStatus = async (newStatus) => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_HELPDESK_API_URL}/api/user/ticket/update-status`,
        {
          status: newStatus,
          ticketId: ticket.id,
        },
      );
      if (res.data.success) {
        fetchTicket(); // refresh ticket data after update
      }
    } catch (err) {
      console.error("Error updating status:", err);
    } finally {
      handleMenuClose();
    }
  };

  useEffect(() => {
    fetchTicket();
    fetchComments();
    fetchHistory();
  }, [id]);

  const [openAttachment, setOpenAttachment] = useState(false);
  const [selectedAttachment, setSelectedAttachment] = useState("");

  // const handleOpenAttachment = (url) => {
  //   setSelectedAttachment(url);
  //   setOpenAttachment(true);
  // };

  const handleCloseAttachment = () => {
    setOpenAttachment(false);
    setSelectedAttachment("");
  };

  const handleAttachmentClick = (url) => {
    if (getFileType(url) === "image") {
      setSelectedAttachment(url);
      setOpenAttachment(true);
    } else {
      setSelectedAttachment(url);
      setOpenAttachment(true); // ✅ Now opens dialog for non-images too
    }
  };

  // Helpers
  const getFileType = (url) => {
    const ext = url.split(".").pop().toLowerCase();
    if (["jpg", "jpeg", "png", "gif", "webp"].includes(ext)) return "image";
    if (["pdf", "doc", "docx", "xls", "xlsx", "txt"].includes(ext))
      return "doc";
    return "other";
  };

  const getFileName = (url) => url.split("/").pop();

  return (
    <Box
      sx={{
        p: 2,
        fontFamily: "Rubik, sans-serif",
        backgroundColor: "#F9FAFB",
      }}
    >
      {/* HEADER */}
      <Paper
        elevation={0}
        sx={{
          p: isMobile ? 2 : 2,
          mb: 3,
          borderRadius: 3,
          background: "linear-gradient(135deg,  #1570EF 0%,  #667eea  100%)",
          color: "white",
        }}
      >
        <Stack direction="row" alignItems="center" spacing={isMobile ? 1 : 2}>
          {/* Back Button */}
          <IconButton
            onClick={() => navigate(-1)}
            sx={{
              color: "white",
              "&:hover": { bgcolor: alpha("#fff", 0.1) },
            }}
          >
            <ArrowBack sx={{ fontSize: isMobile ? 24 : 30 }} />
          </IconButton>

          {/* Title + display_id */}
          <Box sx={{ flexGrow: 1, minWidth: 0 }}>
            <Typography
              sx={{
                fontWeight: 700,
                fontSize: isMobile ? 20 : 28,
                lineHeight: 1.2,
              }}
            >
              Ticket Details
            </Typography>

            {ticket?.display_id && (
              <Chip
                label={`#${ticket.display_id}`}
                size="small"
                sx={{
                  mt: 1,
                  backgroundColor: "rgba(255,255,255,0.2)",
                  color: "#fff",
                  fontWeight: 700,
                  fontSize: isMobile ? "1.5rem" : "1.2rem",
                }}
              />
            )}
          </Box>

          {/* Create Ticket Button */}
          <Tooltip
            title={
              <Typography sx={{ fontSize: "1rem", fontFamily: "Rubik" }}>
                Create Ticket
              </Typography>
            }
            arrow
            placement="bottom"
          >
            <IconButton
              onClick={() => setOpenForm(true)}
              sx={{
                backgroundColor: "rgba(255,255,255,0.2)",
                "&:hover": { backgroundColor: "rgba(255,255,255,0.3)" },
                width: isMobile ? 34 : 40,
                height: isMobile ? 34 : 40,
              }}
            >
              <AddCircleOutline
                sx={{ fontSize: isMobile ? 20 : 26, color: "#fff" }}
              />
            </IconButton>
          </Tooltip>
        </Stack>
      </Paper>

      {loading ? (
        <Box display="flex" justifyContent="center" mt={8}>
          <CircularProgress />
        </Box>
      ) : !ticket ? (
        <Typography textAlign="center" mt={5}>
          Ticket not found
        </Typography>
      ) : (
        <>
          {/* TABS */}
          {/* TABS */}
          {/* <Paper sx={{ mb: 3 }}>
            <Tabs
              value={tab}
              onChange={(e, newValue) => setTab(newValue)}
              indicatorColor="primary"
              textColor="primary"
              variant="scrollable"
              scrollButtons="auto"
              sx={{
                "& .MuiTabs-flexContainer": {
                  gap: 1.5, // spacing between tabs
                },
                "& .MuiTab-root": {
                  fontFamily: "Rubik",
                  fontSize: isMobile ? "2rem" : "1.5rem", // increased font size
                  fontWeight: 600,
                  textTransform: "none",
                  minHeight: 60,
                  padding: isMobile ? "10px 16px" : "14px 24px", // more padding
                },
                "& .Mui-selected": {
                  color: "#1570EF !important",
                },
                "& .MuiTabs-indicator": {
                  height: 4,
                  borderRadius: "4px 4px 0 0",
                  backgroundColor: "#1570EF",
                },
              }}
            >
              <Tab label="Issue Overview" />
              <Tab label="Ticket Ownership" />
              <Tab label="Ticket History" />
              <Tab label={`Comments (${comments.length})`} />
            </Tabs>
          </Paper> */}

          <Paper sx={{ mb: 3 }}>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              sx={{ px: 2 }}
            >
              {/* Tabs on left */}
              <Tabs
                value={tab}
                onChange={(e, newValue) => setTab(newValue)}
                indicatorColor="primary"
                textColor="primary"
                variant="scrollable"
                scrollButtons="auto"
                
                sx={{
                  "& .MuiTabs-flexContainer": { gap: 1.5 },
                  "& .MuiTab-root": {
                    fontFamily: "Rubik",
                    fontSize: isMobile ? "2rem" : "1.5rem",
                    fontWeight: 600,
                    textTransform: "none",
                    minHeight: 60,
                    padding: isMobile ? "10px 16px" : "14px 24px",
                  },
                  "& .Mui-selected": { color: "#1570EF !important" },
                  "& .MuiTabs-indicator": {
                    height: 4,
                    borderRadius: "4px 4px 0 0",
                    backgroundColor: "#1570EF",
                  },
                }}
              >
                <Tab label="Issue Overview" />
                {/* <Tab label="Ticket Ownership" /> */}
                <Tab label="Ticket History" />
                <Tab label={`Comments (${comments.length})`} />
              </Tabs>

              {/* Status + Update Button */}
              <Box>
                {/* Show Chip only on desktop */}
                {!isMobile && (
                  <Chip
                    label={ticket?.status || "Unknown"}
                    color={getStatusColor(ticket?.status)}
                    icon={getStatusIcon(ticket?.status)}
                    sx={{
                      mr: 1,
                      fontWeight: 600,
                      textTransform: "uppercase",
                      fontSize: "1rem",
                    }}
                  />
                )}

                {ticket?.status?.toLowerCase() === "resolved" && (
                  <>
                    {isMobile ? (
                      // Mobile: show only Update Status button
                      <Button
                        variant="outlined"
                        onClick={(e) => setAnchorEl(e.currentTarget)}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          // gap: 0.5,
                          borderRadius: 2,
                          fontWeight: 600,
                          fontSize: "1.9rem",
                          // px: 1.5,
                          // py: 0.5,
                          textTransform: "none",
                          whiteSpace: "nowrap", // ✅ prevent text from breaking into 2 lines
                          minWidth: "auto", // ✅ keeps it tight
                        }}
                      >
                        {/* <MoreVert sx={{ fontSize: "1.6rem" }} /> */}
                        Update Status
                      </Button>
                    ) : (
                      // Desktop: full Update Status button with Chip above
                      <Button
                        variant="outlined"
                        endIcon={<MoreVert />}
                        onClick={(e) => setAnchorEl(e.currentTarget)}
                        sx={{
                          borderRadius: 2,
                          fontWeight: 600,
                          fontSize: "1rem",
                          textTransform: "none",
                        }}
                      >
                        Update Status
                      </Button>
                    )}
                  </>
                )}
              </Box>
            </Stack>
          </Paper>

          <Menu anchorEl={anchorEl} open={isMenuOpen} onClose={handleMenuClose}>
            <MenuItem
              onClick={() => handleUpdateStatus("closed")}
              sx={{
                fontSize: isMobile ? "1.6rem" : "1rem", // ✅ larger font on mobile
                fontWeight: 600,
                color: "error.main",
                "&:hover": {
                  bgcolor: alpha(theme.palette.error.main, 0.1),
                },
              }}
            >
              <Close sx={{ mr: 1, fontSize: 20 }} />
              Close Ticket
            </MenuItem>
          </Menu>

          {/* ISSUE OVERVIEW */}
          {tab === 0 && (
            <Fade in timeout={500}>
              <Paper
                sx={{
                  p: isMobile ? 2 : 4,
                  borderRadius: 3,
                  fontFamily: "Rubik, sans-serif",
                   overflowY:"scroll",
                  height: isMobile ? "50vh" : "60vh",
                }}
              >
                <Typography
                  variant="h6"
                  fontWeight={700}
                  gutterBottom
                  sx={{ fontSize: isMobile ? "2.4rem" : "1.8rem", mb: 2 }}
                >
                  Issue Overview
                </Typography>

                <Grid container spacing={isMobile ? 1.5 : 2}>
                  <Grid item xs={12} md={6}>
                    {/* Subject */}
                    <Typography
                      variant="subtitle1"
                      fontWeight={600}
                      sx={{ fontSize: isMobile ? "2rem" : "1.3rem", mb: 0.5 }}
                    >
                      Subject
                    </Typography>
                    <Typography
                      sx={{ fontSize: isMobile ? "1.8rem" : "1.2rem", mb: 1 }}
                    >
                      {ticket?.subject_line || "-"}
                    </Typography>

                    {/* Description */}
                    <Typography
                      variant="subtitle1"
                      fontWeight={600}
                      sx={{ fontSize: isMobile ? "2rem" : "1.3rem", mb: 0.5 }}
                    >
                      Description
                    </Typography>
                    <Typography
                      sx={{ fontSize: isMobile ? "1.8rem" : "1.2rem", mb: 1 }}
                    >
                      {ticket?.description || "-"}
                    </Typography>

                    {/* Status */}
                    <Typography
                      variant="subtitle1"
                      fontWeight={600}
                      sx={{ fontSize: isMobile ? "2rem" : "1.3rem", mb: 0.5 }}
                    >
                      Status
                    </Typography>
                    <Chip
                      label={ticket.status.toUpperCase() || "-"}
                      color={getStatusColor(ticket.status.toUpperCase())}
                      icon={getStatusIcon(ticket.status.toUpperCase())}
                      sx={{
                        fontSize: isMobile ? "1.5rem" : "1.2rem",
                        fontWeight: 500,
                        mb: 1,
                      }}
                    />

                    {/* Priority */}
                    <Typography
                      variant="subtitle1"
                      fontWeight={600}
                      sx={{ fontSize: isMobile ? "2rem" : "1.3rem", mb: 0.5 }}
                    >
                      Priority
                    </Typography>
                    <Chip
                      label={ticket?.priority_level.toUpperCase() || "-"}
                      sx={{
                        backgroundColor: "#FFF4CC",
                        color: "#946200",
                        fontWeight: 500,
                        fontSize: isMobile ? "1.5rem" : "1.2rem",
                      }}
                    />

                    {/* Attachments */}
                    {(() => {
                      let attachmentList = [];

                      if (Array.isArray(ticket?.attachments)) {
                        attachmentList = ticket.attachments;
                      } else if (typeof ticket?.attachments === "string") {
                        try {
                          attachmentList = JSON.parse(ticket.attachments);
                          if (!Array.isArray(attachmentList)) {
                            attachmentList = [ticket.attachments];
                          }
                        } catch {
                          attachmentList = ticket.attachments.includes(",")
                            ? ticket.attachments.split(",").map((s) => s.trim())
                            : [ticket.attachments];
                        }
                      }

                      return (
                        attachmentList.length > 0 && (
                          <>
                            <Typography
                              variant="subtitle1"
                              fontWeight={600}
                              sx={{
                                fontSize: isMobile ? "2rem" : "1.3rem",
                                mt: 2,
                                mb: 0.5,
                              }}
                            >
                              Attachments ({attachmentList.length})
                            </Typography>

                            <Box display="flex" flexWrap="wrap" gap={1}>
                              {attachmentList.map((url, index) => {
                                const fileType = getFileType(url);
                                return (
                                  <Box
                                    key={index}
                                    sx={{
                                      width: 100,
                                      height: 70,
                                      borderRadius: 1,
                                      cursor: "pointer",
                                      border: "1px solid #ccc",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      overflow: "hidden",
                                      bgcolor:
                                        fileType === "image"
                                          ? "transparent"
                                          : "#F9FAFB",
                                    }}
                                    onClick={() => handleAttachmentClick(url)}
                                  >
                                    {fileType === "image" ? (
                                      <img
                                        src={url}
                                        alt={`Attachment ${index + 1}`}
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                          objectFit: "cover",
                                        }}
                                      />
                                    ) : (
                                      <Typography
                                        sx={{
                                          fontSize: "0.75rem",
                                          textAlign: "center",
                                          px: 0.5,
                                          wordBreak: "break-word",
                                        }}
                                      >
                                        {getFileName(url)}
                                      </Typography>
                                    )}
                                  </Box>
                                );
                              })}
                            </Box>
                          </>
                        )
                      );
                    })()}
                  </Grid>

                  <Grid item xs={12} md={6}>
                    {/* Department */}
                    <Typography
                      variant="subtitle1"
                      fontWeight={600}
                      sx={{ fontSize: isMobile ? "2rem" : "1.3rem", mb: 0.5 }}
                    >
                      Department
                    </Typography>
                    <Typography
                      sx={{ fontSize: isMobile ? "1.8rem" : "1.2rem", mb: 1 }}
                    >
                      {ticket?.department_name || "-"}
                    </Typography>

                    {/* Category */}
                    <Typography
                      variant="subtitle1"
                      fontWeight={600}
                      sx={{ fontSize: isMobile ? "2rem" : "1.3rem", mb: 0.5 }}
                    >
                      Category
                    </Typography>
                    <Typography
                      sx={{ fontSize: isMobile ? "1.8rem" : "1.2rem", mb: 1 }}
                    >
                      {ticket?.category_name || "-"}
                    </Typography>

                    {/* Sub Category */}
                    <Typography
                      variant="subtitle1"
                      fontWeight={600}
                      sx={{ fontSize: isMobile ? "2rem" : "1.3rem", mb: 0.5 }}
                    >
                      Sub Category
                    </Typography>
                    <Typography
                      sx={{ fontSize: isMobile ? "1.8rem" : "1.2rem", mb: 1 }}
                    >
                      {ticket?.subcategory_name || "-"}
                    </Typography>

                    <Divider sx={{ my: isMobile ? 2 : 3 }} />

                    {/* Created At */}
                    <Typography
                      variant="subtitle1"
                      fontWeight={600}
                      sx={{ fontSize: isMobile ? "2rem" : "1.3rem", mb: 0.5 }}
                    >
                      Created At
                    </Typography>
                    <Typography
                      sx={{ fontSize: isMobile ? "1.8rem" : "1.2rem", mb: 1 }}
                    >
                      {formatDate(ticket?.created_at)}
                    </Typography>

                    {/* Last Updated */}
                    <Typography
                      variant="subtitle1"
                      fontWeight={600}
                      sx={{ fontSize: isMobile ? "2rem" : "1.3rem", mb: 0.5 }}
                    >
                      Last Updated
                    </Typography>
                    <Typography
                      sx={{ fontSize: isMobile ? "1.8rem" : "1.2rem", mb: 1 }}
                    >
                      {formatDate(ticket?.last_updated_at)}
                    </Typography>

                    {/* Resolution Deadline */}
                    <Typography
                      variant="subtitle1"
                      fontWeight={600}
                      sx={{ fontSize: isMobile ? "2rem" : "1.3rem", mb: 0.5 }}
                    >
                      Resolution Deadline
                    </Typography>
                    <Typography
                      sx={{ fontSize: isMobile ? "1.8rem" : "1.2rem" }}
                    >
                      {formatDate(ticket?.resolution_deadline)}
                    </Typography>
                  </Grid>
                </Grid>
              </Paper>
            </Fade>
          )}
          <Dialog
            open={openAttachment}
            onClose={handleCloseAttachment}
            maxWidth={false}
            fullWidth={false}
            PaperProps={{
              sx: {
                borderRadius: 2,
                overflow: "hidden",
                width: { xs: "90vw", sm: "700px", md: "1000px" }, // wider sizes
                maxWidth: "95vw", // safety to avoid overflow on small screens
              },
            }}
          >
            {/* Header  */}
            <Box
              sx={{
                height: 56,
                px: 2,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                bgcolor: "fff",
                color: "#000",
              }}
            >
              {/* Left: file icon + name */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1.5,
                  minWidth: 0,
                }}
              >
                {getFileType(selectedAttachment) === "image" ? (
                  <ImageOutlined fontSize="large" />
                ) : (
                  <InsertDriveFileOutlined fontSize="large" />
                )}
                <Typography
                  noWrap
                  sx={{
                    opacity: 0.95,
                    maxWidth: { xs: "45vw", sm: "60vw" },
                    fontSize: "1.5rem",
                  }}
                  title={getFileName(selectedAttachment)}
                >
                  {getFileName(selectedAttachment)}
                </Typography>
              </Box>

              {/* Right: Download button + Close */}
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                {/* <Button
                  variant="contained"
                  size="small"
                  startIcon={<FileDownloadOutlinedIcon />}
                  sx={{
                    bgcolor: "#1570EF",
                    textTransform: "none",
                    "&:hover": { bgcolor: "#125ac4" },
                  }}
                  onClick={async () => {
                    try {
                      const res = await fetch(selectedAttachment, {
                        mode: "cors",
                      });
                      const blob = await res.blob();
                      const objectUrl = window.URL.createObjectURL(blob);
                      const a = document.createElement("a");
                      a.href = objectUrl;
                      a.download = getFileName(selectedAttachment);
                      document.body.appendChild(a);
                      a.click();
                      a.remove();
                      window.URL.revokeObjectURL(objectUrl);
                    } catch (e) {
                      console.error("Download failed:", e);
                    }
                  }}
                >
                  <Typography sx={{ fontSize: "1.3rem" }}> Download</Typography>
                </Button> */}
                <IconButton
                  onClick={handleCloseAttachment}
                  sx={{ color: "black" }}
                >
                  <Close />
                </IconButton>
              </Box>
            </Box>

            {/* Body: light gray canvas with centered preview */}
            <Box
              sx={{
                bgcolor: "#F9FAFB",
                minHeight: { xs: "60vh", md: "75vh" },
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                p: { xs: 2, sm: 3 },
              }}
            >
              {getFileType(selectedAttachment) === "image" ? (
                <img
                  src={selectedAttachment}
                  alt="Attachment Preview"
                  style={{
                    maxWidth: "100%",
                    maxHeight: "80vh",
                    objectFit: "contain",
                    borderRadius: "8px",
                  }}
                />
              ) : (
                <Box
                  sx={{
                    textAlign: "center",
                    p: 4,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 2,
                  }}
                >
                  {/* File Icon */}
                  <InsertDriveFileOutlined sx={{ fontSize: 60 }} />

                  {/* Title */}
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 700,
                      color: "#111827",
                      fontSize: "1.5rem",
                    }}
                  >
                    Document File
                  </Typography>

                  {/* Description */}
                  <Typography
                    sx={{ color: "#6B7280", mb: 2, fontSize: "1.2rem" }}
                  >
                    This document can be downloaded to view its contents.
                  </Typography>

                  {/* Download File */}
                  <Button
                    variant="contained"
                    fullWidth
                    startIcon={<FileDownloadOutlinedIcon />}
                    sx={{
                      bgcolor: "#2563EB",
                      textTransform: "none",
                      fontWeight: 500,
                      "&:hover": { bgcolor: "#1D4ED8" },
                    }}
                    onClick={async () => {
                      try {
                        const res = await fetch(selectedAttachment, {
                          mode: "cors",
                        });
                        const blob = await res.blob();
                        const url = window.URL.createObjectURL(blob);
                        const a = document.createElement("a");
                        a.href = url;
                        a.download = getFileName(selectedAttachment);
                        document.body.appendChild(a);
                        a.click();
                        a.remove();
                        window.URL.revokeObjectURL(url);
                      } catch (e) {
                        console.error("Download failed:", e);
                      }
                    }}
                  >
                    <Typography sx={{ fontSize: "1.5rem" }}>
                      Download File
                    </Typography>
                  </Button>

                  {/* Open in New Tab */}
                  <Button
                    variant="outlined"
                    fullWidth
                    sx={{
                      textTransform: "none",
                      borderColor: "#1D4ED8",
                      color: "#1D4ED8",
                      "&:hover": {
                        borderColor: "#1D4ED8",
                        bgcolor: "#d5def1ff",
                      },
                    }}
                    onClick={() => {
                      const encodedUrl = encodeURIComponent(selectedAttachment);
                      const ext = getFileName(selectedAttachment)
                        .split(".")
                        .pop()
                        .toLowerCase();

                      // Use Microsoft Office Viewer for Word, Excel, PowerPoint
                      if (
                        ["doc", "docx", "xls", "xlsx", "ppt", "pptx"].includes(
                          ext,
                        )
                      ) {
                        window.open(
                          `https://view.officeapps.live.com/op/view.aspx?src=${encodedUrl}`,
                          "_blank",
                        );
                      }
                      // Open PDFs and images directly
                      else if (
                        ["pdf", "jpg", "jpeg", "png", "gif", "webp"].includes(
                          ext,
                        )
                      ) {
                        window.open(selectedAttachment, "_blank");
                      }
                      // Fallback: just try opening in new tab
                      else {
                        window.open(selectedAttachment, "_blank");
                      }
                    }}
                  >
                    <Typography sx={{ fontSize: "1.5rem" }}>
                      Open in New Tab
                    </Typography>
                  </Button>
                </Box>
              )}
            </Box>
          </Dialog>

          {/* TICKET OWNERSHIP */}
          {/* {tab === 1 && (
            <Fade in timeout={500}>
              <Paper
                sx={{
                  p: isMobile ? 2 : 4,
                  borderRadius: 3,
                  fontFamily: "Rubik, sans-serif",
                  fontSize: isMobile ? "2.4rem" : "1.8rem",
                }}
              >
                <Typography
                  variant="h6"
                  fontWeight={700}
                  gutterBottom
                  sx={{ fontSize: isMobile ? "2.4rem" : "1.8rem", mb: 2 }}
                >
                  Ticket Ownership
                </Typography>

                <Grid container spacing={isMobile ? 2 : 4}>
                  
                  <Grid item xs={12} md={6}>
                    <Typography
                      variant="subtitle1"
                      color="text.secondary"
                      sx={{
                        mb: 1,
                        fontSize: isMobile ? "2rem" : "1.3rem",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      Submitted by
                    </Typography>
                    <Stack spacing={1.2} mt={1}>
                      <Typography
                        sx={{
                          fontSize: isMobile ? "1.8rem" : "1.3rem",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <Person
                          sx={{
                            fontSize: isMobile ? 18 : 20,
                            color: "#1570EF",
                            mr: 1,
                          }}
                        />
                        <strong>Name:</strong>&nbsp;
                        {ticket?.customer_name || "-"}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: isMobile ? "1.8rem" : "1.3rem",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <Mail
                          sx={{
                            fontSize: isMobile ? 18 : 20,
                            color: "#1570EF",
                            mr: 1,
                          }}
                        />
                        <strong>Email:</strong>&nbsp;
                        {ticket?.customer_email || "-"}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: isMobile ? "1.8rem" : "1.3rem",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <Phone
                          sx={{
                            fontSize: isMobile ? 18 : 20,
                            color: "#1570EF",
                            mr: 1,
                          }}
                        />
                        <strong>Mobile:</strong>&nbsp;
                        {ticket?.customer_mobile || "-"}
                      </Typography>
                    </Stack>
                  </Grid>

                 
                  <Grid item xs={12} md={6}>
                    <Typography
                      variant="subtitle1"
                      color="text.secondary"
                      sx={{
                        mb: 1,
                        fontSize: isMobile ? "2rem" : "1.3rem",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      Assigned to
                    </Typography>
                    <Stack spacing={1.2} mt={1}>
                      <Typography
                        sx={{
                          fontSize: isMobile ? "1.8rem" : "1.3rem",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <Person
                          sx={{
                            fontSize: isMobile ? 18 : 20,
                            color: "#1570EF",
                            mr: 1,
                          }}
                        />
                        <strong>Name:</strong>&nbsp;{ticket?.user?.name || "-"}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: isMobile ? "1.8rem" : "1.3rem",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <Mail
                          sx={{
                            fontSize: isMobile ? 18 : 20,
                            color: "#1570EF",
                            mr: 1,
                          }}
                        />
                        <strong>Email:</strong>&nbsp;
                        {ticket?.user?.email || "-"}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: isMobile ? "1.8rem" : "1.3rem",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <Phone
                          sx={{
                            fontSize: isMobile ? 18 : 20,
                            color: "#1570EF",
                            mr: 1,
                          }}
                        />
                        <strong>Mobile:</strong>&nbsp;
                        {ticket?.user?.mobile || "-"}
                      </Typography>
                    </Stack>
                  </Grid>
                </Grid>
              </Paper>
            </Fade>
          )} */}

          {/* TICKET HISTORY */}
          {tab === 1 && (
            <Fade in timeout={500}>
              <Paper
                sx={{
                  p: isMobile ? 2 : 4,
                  borderRadius: 3,
                  fontFamily: "Rubik, sans-serif",
                  bgcolor: "#F9FAFB",
                  overflowY:"scroll",
                  height: isMobile ? "50vh" : "60vh",
                }}
              >
                {/* Header */}
                <Stack direction="row" alignItems="center" spacing={1} mb={3}>
                  {/* <AccessTime sx={{ color: "#000000ff" }} /> */}
                  <Typography
                    variant="h6"
                    fontWeight={700}
                    sx={{
                      fontSize: isMobile ? "2.4rem" : "1.8rem",
                      color: "#1E293B",
                    }}
                  >
                    Ticket History
                  </Typography>
                </Stack>

                {history.length === 0 ? (
                  <Typography
                    color="text.secondary"
                    sx={{ fontSize: "1.5rem" }}
                  >
                    No history available.
                  </Typography>
                ) : (
                  <Box sx={{ position: "relative", pl: isMobile ? 0 : 2 }}>
                    <Stack spacing={4} sx={{ position: "relative" }}>
                      {/* Vertical Line */}
                      <Box
                        sx={{
                          position: "absolute",
                          top: 0,
                          bottom: 0,
                          left: 20,
                          width: "2px",
                          bgcolor: "#CBD5E1",
                        }}
                      />

                      {history.map((h, i) => (
                        <Stack
                          key={i}
                          direction="row"
                          spacing={2}
                          alignItems="flex-start"
                        >
                          {/* Dot (centered on line) */}
                          <Box
                            sx={{
                              position: "relative",
                              minWidth: "40px",
                              height: "100%",
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <Box
                              sx={{
                                width: isMobile ? 10 : 14,
                                height: isMobile ? 10 : 14,
                                borderRadius: "50%",
                                backgroundColor: "#1570EF",
                                border: "3px solid white",
                                boxShadow: "0 0 0 2px #CBD5E1",
                                mt: 0.5,
                              }}
                            />
                          </Box>

                          {/* Timeline Card */}
                          <Paper
                            elevation={2}
                            sx={{
                              p: isMobile ? 2 : 3,
                              borderRadius: 2,
                              bgcolor: "white",
                              borderLeft: "4px solid #1570EF",
                              boxShadow: "0px 4px 12px rgba(0,0,0,0.04)",
                              flexGrow: 1,
                            }}
                          >
                            <Typography
                              sx={{
                                fontWeight: 700,
                                fontSize: isMobile ? "2rem" : "1.5rem",
                                color: "#1570EF",
                                mb: 0.5,
                              }}
                            >
                              {h.actions || "Comment"}
                            </Typography>

                            {h.description && (
                              <Typography
                                sx={{
                                  fontSize: isMobile ? "1.5rem" : "1.3rem",
                                  mb: 0.5,
                                }}
                              >
                                <strong>Description:</strong> {h.description}
                              </Typography>
                            )}

                            {h.message && (
                              <Typography
                                sx={{
                                  fontSize: isMobile ? "2rem" : "1.5rem",
                                  fontStyle: "italic",
                                  color: "#334155",
                                  mb: 1,
                                }}
                              >
                                {h.message}
                              </Typography>
                            )}

                            <Typography
                              sx={{
                                fontSize: isMobile ? "1.5rem" : "1.2rem",
                                color: "#64748B",
                                fontWeight: 500,
                              }}
                            >
                              On:{" "}
                              {formatDate(h.ticket_assigned_at || h.created_at)}
                            </Typography>
                          </Paper>
                        </Stack>
                      ))}
                    </Stack>
                  </Box>
                )}
              </Paper>
            </Fade>
          )}

          {/* COMMENTS */}
          {tab === 2 && (
            <Fade in timeout={500}>
              <Paper
                sx={{
                  p: isMobile ? 2 : 4,
                  borderRadius: 3,
                  fontFamily: "Rubik, sans-serif",
                  bgcolor: "#F9FAFB",
                   overflowY:"scroll",
                  height: isMobile ? "50vh" : "60vh",
                }}
              >
                <Typography
                  variant="h6"
                  fontWeight={700}
                  gutterBottom
                  sx={{
                    fontSize: isMobile ? "2.2rem" : "1.8rem",
                    color: "#1E293B",
                  }}
                >
                  Comments ({comments.length})
                </Typography>

                <Stack spacing={3} mb={3}>
                  {comments.length === 0 ? (
                    <Typography
                      color="text.secondary"
                      sx={{ fontSize: isMobile ? "1.6rem" : "1.2rem" }}
                    >
                      No comments yet.
                    </Typography>
                  ) : (
                    comments.map((c) => {
                      //both comments of on side whether from  logged in cp or from helpdesk login

                      // const isCurrentUser = c.customer_name === ticket.customer_name
                      //   || c.users?.name === ticket.customer_name
                      //   || (c.user_id === null && c.users === null);

                      // // ✅ Show Yogesh (ticket.customer_name) for all his comments
                      // const senderName = isCurrentUser
                      //   ? ticket.customer_name
                      //   : c.users?.name || "User";
                      // Customer’s own comment
                      const isCurrentUser =
                        c.user_id === null && c.users === null;

                      // Sender name logic
                      let senderName = isCurrentUser
                        ? ticket.customer_name
                        : c.users?.name || "User";
                      console.log("ticket.customer_name", ticket.customer_name);
                      return (
                        <Box
                          key={c.id}
                          sx={{
                            display: "flex",
                            justifyContent: isCurrentUser
                              ? "flex-end"
                              : "flex-start",
                          }}
                        >
                          <Paper
                            sx={{
                              maxWidth: "80%",
                              p: 2,
                              backgroundColor: isCurrentUser
                                ? "#428bf1ff"
                                : "#F1F5F9",
                              color: isCurrentUser ? "#ffffff" : "#0F172A",
                              borderRadius: 3,
                              borderBottomRightRadius: isCurrentUser ? 0 : 3,
                              borderBottomLeftRadius: isCurrentUser ? 3 : 0,
                              boxShadow: "0 4px 8px rgba(0,0,0,0.05)",
                            }}
                          >
                            {/* Name */}
                            <Typography
                              fontWeight={600}
                              sx={{
                                fontSize: isMobile ? "1.7rem" : "1.3rem",
                                mb: 0.5,
                              }}
                            >
                              {senderName} {isCurrentUser && "(You)"}
                            </Typography>

                            {/* Timestamp */}
                            <Typography
                              variant="caption"
                              sx={{
                                opacity: 0.8,
                                fontSize: isMobile ? "1.7rem" : "1.2rem",
                                display: "block",
                                mb: 1,
                              }}
                            >
                              {formatDate(c.created_at)}
                            </Typography>

                            {/* Message */}
                            <Typography
                              sx={{
                                fontSize: isMobile ? "1.7rem" : "1.2rem",
                                whiteSpace: "pre-wrap",
                                wordBreak: "break-word",
                              }}
                            >
                              {c.message}
                            </Typography>

                            {/* {c.attachments ||
                              (c.image && (
                                <Box
                                  sx={{
                                    mt: 1,
                                    display: "inline-block",
                                    maxWidth: "100%",
                                  }}
                                >
                                  <img
                                    src={c.attachments || c.image}
                                    alt="Preview"
                                    style={{
                                      width: "200px", // fixed width
                                      height: "auto", // keep aspect ratio
                                      maxHeight: "180px", // optional cap for very tall images
                                      borderRadius: "8px",
                                      objectFit: "cover",
                                      border: "1px solid #E5E7EB",
                                      boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                                      cursor: "pointer",
                                    }}
                                    onClick={() =>
                                      window.open(
                                        c.attachments || c.image,
                                        "_blank"
                                      )
                                    } // open full-size on click
                                  />
                                </Box>
                              ))} */}
                            {(() => {
                              let imageUrl = null;

                              // If attachments already a direct URL
                              if (c.attachments && c.attachments !== "[]") {
                                imageUrl = c.attachments;
                              }

                              // If image is JSON string (new backend format)
                              else if (c.image && c.image !== "[]") {
                                try {
                                  const parsed = JSON.parse(c.image);
                                  imageUrl = parsed?.[0]?.url || null;
                                } catch (err) {
                                  imageUrl = c.image; // fallback for old format
                                }
                              }

                              return imageUrl ? (
                                <Box
                                  sx={{
                                    mt: 1,
                                    display: "inline-block",
                                    maxWidth: "100%",
                                  }}
                                >
                                  <img
                                    src={imageUrl}
                                    alt="Preview"
                                    style={{
                                      width: "200px",
                                      height: "auto",
                                      maxHeight: "180px",
                                      borderRadius: "8px",
                                      objectFit: "cover",
                                      border: "1px solid #E5E7EB",
                                      boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                                      cursor: "pointer",
                                    }}
                                    onClick={() =>
                                      window.open(imageUrl, "_blank")
                                    }
                                  />
                                </Box>
                              ) : null;
                            })()}
                          </Paper>
                        </Box>
                      );
                    })
                  )}
                </Stack>
                <Divider sx={{ my: 2 }} />

                {/* Comment input */}
                <Box>
                  <TextField
                    fullWidth
                    placeholder="Add a comment..."
                    multiline
                    minRows={3}
                    value={newComment}
                    onChange={(e) => {
                      setNewComment(e.target.value);
                      if (commentError) setCommentError(""); // clear error while typing
                    }}
                    error={Boolean(commentError)}
                    helperText={commentError || ""}
                    FormHelperTextProps={{
                      sx: {
                        fontSize: isMobile ? "1.5rem" : "1rem",
                        fontFamily: "Rubik",
                        color: "red",
                        fontWeight: 600,
                      },
                    }}
                    InputProps={{
                      sx: { fontSize: isMobile ? "2rem" : "1.2rem" },
                    }}
                    sx={{
                      fontFamily: "Rubik",
                      backgroundColor: "#fff",
                      borderRadius: 2,
                    }}
                  />

                  {/* Attach image */}
                  {!attachedImage ? (
                    <Box mt={1} display="flex" alignItems="center" gap={1}>
                      <Button
                        variant="outlined"
                        component="label"
                        startIcon={<AttachFileIcon />}
                        fullWidth={isMobile}
                        sx={{
                          fontWeight: 600,
                          textTransform: "none",
                          fontSize: isMobile ? "1.8rem" : "1.2rem",
                          color: "#000000ff",
                          px: 1.5,
                          py: isMobile ? 1 : 0.8,
                          borderRadius: 2,
                          "& .MuiButton-startIcon": {
                            mr: 0.5,
                          },
                        }}
                      >
                        Attach Image
                        <input
                          type="file"
                          hidden
                          accept="image/*"
                          onChange={handleImageChange}
                        />
                      </Button>

                      <Typography
                        sx={{
                          color: "#64748B",
                          fontSize: isMobile ? "1.6rem" : "1rem",
                        }}
                      >
                        Attach an image to provide visual context
                      </Typography>
                    </Box>
                  ) : (
                    <Paper
                      variant="outlined"
                      sx={{
                        mt: 2,
                        p: 1.5,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        bgcolor: "#F9FAFB",
                        borderRadius: 2,
                      }}
                    >
                      <Box display="flex" alignItems="center" gap={2}>
                        {/* Image preview */}
                        <img
                          src={attachedImage.url}
                          alt="attachment"
                          style={{
                            width: 60,
                            height: 60,
                            objectFit: "cover",
                            borderRadius: 6,
                            border: "1px solid #E5E7EB",
                          }}
                        />
                        <Typography
                          sx={{
                            color: "green",
                            fontWeight: 600,
                            fontSize: isMobile ? "1.6rem" : "1.2rem",
                          }}
                        >
                          Image attached
                        </Typography>
                      </Box>

                      <Button
                        variant="outlined"
                        color="error"
                        onClick={handleRemoveImage}
                        sx={{
                          fontSize: isMobile ? "1.6rem" : "1.2rem",
                          fontWeight: 600,
                        }}
                      >
                        Remove Image
                      </Button>
                    </Paper>
                  )}

                  {/* Send button */}
                  <Box mt={2} display="flex" justifyContent="flex-end">
                    <Button
                      variant="contained"
                      onClick={handleAddComment}
                      disabled={
                        submittingComment ||
                        (!newComment.trim() && !attachedImage)
                      }
                      sx={{
                        bgcolor: "#2563EB",
                        textTransform: "none",
                        fontWeight: 600,
                        fontSize: isMobile ? "1.6rem" : "1.2rem",
                        px: 2.5,
                        "&:hover": { bgcolor: "#1D4ED8" },
                      }}
                    >
                      {submittingComment ? "Posting..." : "Send Comment"}
                    </Button>
                  </Box>
                </Box>
              </Paper>
            </Fade>
          )}
        </>
      )}
      <Dialog
        open={openForm}
        onClose={() => setOpenForm(false)}
        fullWidth
        maxWidth="md"
        scroll="paper"
        PaperProps={{
          sx: {
            display: "flex",
            flexDirection: "column",
            height: "90vh",
            borderRadius: 4,
          },
        }}
      >
        <DialogTitle
          sx={{
            fontFamily: "Rubik",
            fontWeight: 700,
            fontSize: isMobile ? "2rem" : "1.5rem",
            background: "linear-gradient(135deg, #667eea 0%, #1570EF 100%)",
            color: "#fff",
            py: 2,
          }}
        >
          Create Support Ticket
        </DialogTitle>

        {/* Form inside scrollable box */}
        <Box sx={{ flex: 1, overflowY: "auto" }}>
          <TicketPage
            onClose={() => setOpenForm(false)}
            setSubmitRef={(fn) => (submitTicketRef.current = fn)}
          />
        </Box>
      </Dialog>
    </Box>
  );
};

export default TicketDetails;
